module.exports = __webpack_public_path__ + "img/contact-big.f4b4b1ff.svg";